import React, { FC } from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { RouteWrapper } from '../components/RouteWrapper';
import { authenticatedRoot, AuthenticatedRoutes } from './AuthenticatedRoutes';

import { ChooseOrganizationPage } from '../pages/ChooseOrganization';
import { AuthLayout } from '../layouts/AuthLayout';
import { UnverifiedAccountPage } from '../pages/UnverifiedAccount';
import { RedirectProps } from 'react-router';

/* eslint prettier/prettier: ["error", { printWidth: 1000 }] */

const PostponeRedirect: FC<RedirectProps> = (props) => {
  const { pathname, search } = useLocation();
  return <Redirect {...props} to={`${props.to}?redirect=${encodeURIComponent(`${pathname}${search}`)}`} />;
};

export const NoOrganizationSelectedRouter: FC = () => {
  return (
    <Switch>
      <RouteWrapper exact path={AuthenticatedRoutes.ChooseOrganization()} component={ChooseOrganizationPage} layout={AuthLayout} />
      <RouteWrapper exact path={AuthenticatedRoutes.Unverified()} component={UnverifiedAccountPage} layout={AuthLayout} />
      <PostponeRedirect from={authenticatedRoot} to={AuthenticatedRoutes.ChooseOrganization()} />
    </Switch>
  );
};
